import { CSSProperties } from "react";
import {
  FileIcon,
  MenuIcon,
  MoveToIcon,
  RightArrowIcon,
  TicketIcon,
} from "pages/support-tickets/icons";
import { Popover } from "antd";
import { priorityColorObj, ticketStatusConversion } from "./constants";
import { priorityArr } from "../tickets-search-filter/constants";
import styles from "./styles.module.scss";

export function Ticket({
  ticketData,
  handleUpdateStatus,
  handleOpenModal,
  setTicketData,
}: any) {
  function handleTicketClick(e: any) {
    e.stopPropagation();

    const children: any = Array.from(e.target?.children);

    const btnClass: any =
      (children?.length && Array.from(children[0]?.classList)?.[0]) || null;

    const classListCheck =
      (children?.length &&
        Array.from(children[0]?.classList)?.includes(
          "ant-popover-inner-content"
        )) ||
      (btnClass && btnClass?.includes("popoverBtn"));

    const tagsArr = ["BUTTON", "svg", "circle", "path", "SPAN"];
    if (tagsArr.includes(e.target?.tagName) || classListCheck) return;

    setTicketData(ticketData);
    handleOpenModal();
  }

  return (
    <div className={styles.ticket} onClick={handleTicketClick}>
      <TicketHeader
        title={ticketData?.topic}
        ticketId={ticketData?.ticket_id}
        handleUpdateStatus={handleUpdateStatus}
      />

      <TicketBody topic={ticketData?.description} />

      <TicketFooter ticketData={ticketData} />
    </div>
  );
}

function TicketHeader({ title, handleUpdateStatus, ticketId }: any) {
  function PriorityPopover() {
    return (
      <div className={styles.popover}>
        <Popover placement="right" content={<Preferences />} trigger="click">
          <button className={styles.popoverBtn}>
            <MoveToIcon /> Move to{" "}
            <RightArrowIcon className={styles.rightArrow} />
          </button>
        </Popover>
      </div>
    );
  }

  function Preferences() {
    return (
      <div className={styles.preferences}>
        {priorityArr.map((state: any) => {
          return (
            <button
              type="button"
              style={{ "--color": state.color } as CSSProperties}
              className={styles.priority}
              onClick={() => {
                handleUpdateStatus({
                  ticketId: ticketId,
                  value: ticketStatusConversion[state.label],
                });
              }}
            >
              <span></span>
              {state.label}
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div className={styles.ticketHeader}>
      <h2 className={styles.title}>{title}</h2>
      <Popover
        content={<PriorityPopover />}
        trigger="click"
        placement="bottom"
        overlayClassName={styles["custom-popover"]}
      >
        <button className={styles.menuIcon}>
          <MenuIcon />
        </button>
      </Popover>
    </div>
  );
}

function TicketBody({ topic }: any) {
  return (
    <div className={styles.ticketBody}>
      <p>{topic}</p>
    </div>
  );
}

function TicketFooter({ ticketData }: any) {
  const { priority, ticket_id, username, sportsName } = ticketData || {};
  const sport = sportsName?.slice(0, 1).toUpperCase() + sportsName?.slice(1);
  return (
    <div className={styles.ticketFooter}>
      <div className={styles.ticketInfo}>
        <div
          className={styles.priority}
          style={{ backgroundColor: priorityColorObj[priority] }}
        >
          {priority}
        </div>
        <div className={styles.ticketNo}>
          <TicketIcon />
          {ticket_id}
        </div>
        <div className={styles.sportType}>{sport}</div>
        <div className={styles.date}>03 Jul</div>
      </div>

      <div className={styles.files}>
        <div className={styles.name}>
          <img
            src={require("../../../../icons/avatar.png")}
            alt="user-avatar"
          />
          {username}
        </div>
        <FileIcon /> 0 Files
      </div>
    </div>
  );
}
